import Button from 'components/atoms/button';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import SectionData from 'types/SectionData';
import { AuthContext } from 'utils/AuthProvider';

import SkillData from '../../../types/skillData';

import './DefaultContent.scss';
import './SkillCard.scss';
import { truncate } from 'lodash';

interface DefaultContentProps {
  skill: SkillData;
  showButtons?: boolean;
  isEnrolled?: boolean;
  firstIncompleteSection?: SectionData | null;
}

export default function DefaultContent({ skill, isEnrolled, firstIncompleteSection }: DefaultContentProps) {
  const navigate = useNavigate();
  const { user } = useContext(AuthContext)!;

  const routeChangeToSkillPage = () => {
    let path = `/skills/${skill.slug}`;
    navigate(path);
  };
  const routeChangeToContent = () => {
    if (!firstIncompleteSection || !user) {
      navigate({
        pathname: '/register',
        search: `?redirectTo=/skills/${skill.slug}`,
      });
      return;
    }
    const pathToFirstIncompleteSection = `/skills/${skill.slug}/sections/${firstIncompleteSection.slug}`;
    const pathToSkillStart = `/skills/${skill.slug}`;
    let path = '';

    if (isEnrolled === false && firstIncompleteSection !== undefined && firstIncompleteSection !== null) {
      // Not enrolled
      path = pathToFirstIncompleteSection;
    } else {
      path = firstIncompleteSection ? pathToFirstIncompleteSection : pathToSkillStart;
    }
    navigate(path);
  };

  return (
    <div className="default-content">
      <div className="default">
        <h3 className="skill-heading single-line-truncate skill-name">{skill.name}</h3>
        <p className="description mb-2">{truncate(skill.description, { length: 80 })}</p>
      </div>
      <div className="on-hover">
        <h3 className="skill-heading skill-name">{skill.name}</h3>
        <p className="description mb-4">{truncate(skill.description, { length: 200 })}</p>
        <div className="button-container mt-auto">
          <Button visualType="secondary" onClick={routeChangeToSkillPage}>
            More info
          </Button>
          <Button onClick={routeChangeToContent}>Start Skill</Button>
        </div>
      </div>
    </div>
  );
}
